import { useState, useRef, useEffect } from 'react';
import './select.css';

export function Select({ value, onChange, options }) {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedOption = options.find(opt => opt.value === value);

    const handleOptionClick = (optionValue) => {
        // Создаем искусственное событие для совместимости
        const syntheticEvent = {
            target: { value: optionValue },
            preventDefault: () => {},
            stopPropagation: () => {}
        };
        
        // Вызываем onChange с искусственным событием
        if (onChange) {
            onChange(syntheticEvent);
        }
        setIsOpen(false);
    };

    return (
        <div className="custom-select" ref={selectRef}>
            <div 
                className="select-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{selectedOption?.label || 'Выберите...'}</span>
                <span className={`arrow ${isOpen ? 'open' : ''}`}></span>
            </div>
            {isOpen && (
                <div className="select-options">
                    {options.map(option => (
                        <div
                            key={option.value}
                            className={`option ${option.value === value ? 'selected' : ''}`}
                            onClick={() => handleOptionClick(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}